export type RandomItem = { id: string };

export function chooseRandomItem<T extends RandomItem>(
  items: T[],
  currentId?: string,
  random: () => number = Math.random,
): T | undefined {
  if (items.length < 2) return items[0];
  const choices = items.filter((item) => item.id !== currentId);
  return choices[Math.floor(random() * choices.length)] ?? choices[0];
}
